import React, { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import cn from "classnames";

import { actions as referralRequestsActions } from "../../actions/referralRequests";
import { modals } from "../../constants/referralRequests";
import { hasImportableItems, normalizeImportReady } from "../../helpers/referralImport";
import styles from "./importBanner.module.css";

export const ImportBanner = ({ importReady }) => {
  const { t } = useTranslation();
  const normalizedImportReady = normalizeImportReady(importReady);
  const isImportReadyValid = Boolean(normalizedImportReady);

  const dispatch = useDispatch();
  const toggleActivityOfModal = useCallback(
    (modal, isActive) =>
      dispatch(
        referralRequestsActions.toggleActivityOfModal({
          modal,
          isActive
        })
      ),
    [dispatch]
  );

  useEffect(() => {
    if (!isImportReadyValid) {
      dispatch(referralRequestsActions.getImportReady());
    }
  }, [dispatch, isImportReadyValid]);

  if (!hasImportableItems(normalizedImportReady)) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <p className={styles.bannerText}>
        <span> Import your requests </span>
        (You can import your submitted messages, referral requests, or questions through our directories)
      </p>
      <button className={cn("button", styles.buttonImport)} type="button" onClick={() => toggleActivityOfModal(modals.importing, true)}>
        {t("dashboard_referrals_import_confirmation_import_button")}
      </button>
    </div>
  );
};
